export default __webpack_public_path__ + "static/media/666.5972729d.gif";